<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Bank Group</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="bankGroup.id === null">New</span>
              <span v-else>
                {{ bankGroup.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-9">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="bankGroup.name" class="form-control"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updateBankGroup" class="btn btn-sm btn-primary pull-right" v-show="bankGroup.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createBankGroup" class="btn btn-sm btn-primary pull-right" v-show="bankGroup.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <pre>
      <!-- {{ bankGroup }} -->
    </pre>
  </div>
</template>

<script>
import axios from 'axios'
import { bankGroupUrl, getHeader } from '../../config'

export default {
  name: 'BankGroupForm',
  props: ['bankGroup'],
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateBankGroup () {
      axios.put(bankGroupUrl + '/' + this.bankGroup.id, this.bankGroup, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('BankGroup', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
    },
    createBankGroup () {
      axios.post(bankGroupUrl, this.bankGroup, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal('Error!!', response.data, 'error')
        })
    }
  }
}
</script>
